<template>
  <div>
    <el-dialog
      top="10vh"
      width="330px"
      center
      title="请再次确认金额正确性"
      :visible="confirmDialogObj.visible"
      @close="close()"
    >
      <el-form label-width="70px">
        <el-form-item label="确认金额">
          <span class="amount-confirm-text">
            {{
              formatNumberWithCommasAndDecimalSeparator(
                confirmDialogObj.amount,
                4
              )
            }}
          </span>
        </el-form-item>
        <div class="amount-hits">确定要提交吗？</div>
      </el-form>
      <div style="text-align: center; margin-top: 15px">
        <el-button round @click="close()"> 返回 </el-button>
        <el-button
          :loading="confirmDialogObj.confirmSubmitLoading"
          round
          type="primary"
          @click="submit()"
        >
          确定提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";

export default {
  mixins: [mainCommon],
  props: ["confirmDialogObj"],
  methods: {
    close() {
      this.$emit("update:confirm-dialog-obj", { amount: 0 });
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style scoped>
.amount-confirm-text {
  background: linear-gradient(to right, #ff0000, #f56c6c);
  border-image: linear-gradient(to right, #ff0000, #f56c6c);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  font-size: 38px;
  font-weight: 600;
  border-bottom: 3px solid transparent;
  padding-bottom: 5px;
  letter-spacing: 2px;
  border-image-slice: 1;
}
.amount-hits {
  color: #409eff;
  font-weight: 600;
  text-align: center;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/ConfirmDialog.vue